<template>
    <span class="da-apy-span">
        APY
        <da-tooltip class="apy-tooltip-span" :class="apyTooltipIconCSSClass" :iconVersion="iconVersion" :title="apyTitleText"></da-tooltip>
    </span>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
import DaTooltip from "./da-tooltip.vue"

export default defineComponent({
    components:{
        daTooltip: DaTooltip
    },
    props: {
        apyTooltipIconCSSClass: String,
        iconVersion: String
    },
    data() {
        return {
            apyTitleText: "APY = Annual Percentage Yield <br/> Rates as of " + new Date().toLocaleDateString()
        }
    }
})
</script>
<style>
.da-apy-span {
    white-space: nowrap;
}
.apy-tooltip-span {
    pointer-events: all;
}
</style>